import {get, post, deleteMethod} from "@iflat/iflat-ui/src/api/methods";
import {getExtensionByName, isEmpty, routeLink, toFirstLetter} from "@iflat-ui/libs/helpTools";
import axios from "axios";

const fileApi = {
  async createItem({file, name, collection, is_visible_for_client, data}, {ownerType, ownerId}) {
    let formData = data
    if (!data) {
      formData = new FormData()
      formData.append('file', file, name)
      if (collection)
        formData.append('collection', collection)
      if (is_visible_for_client)
        formData.append('is_visible_for_client', is_visible_for_client)
    }

    const res = await post(`/owners/${ownerType}/${ownerId}/attachments`, formData)
    return res.data
  },

  async updateItem(id, data, {ownerType, ownerId}) {
    data.append('_method', 'PUT')
    const res = await post(`/owners/${ownerType}/${ownerId}/attachments/${id}`, data)
    return res.data
  },

  deleteItem(fileId, {ownerType, ownerId}) {
    return deleteMethod(`/owners/${ownerType}/${ownerId}/attachments/${fileId}`)
  },

  async createAudioToText (formData) {
    const res = await post(`/speechToText`, formData)
    return res.data
  },

  async exportFile(url, filters) {
    const res = await post(null, {filters}, {url})
    fileApi.getItem(res.data.file)
  },

  getItem(file) {
    if(isEmpty(file)) return
    routeLink(`/tempFiles/${file}`);
  },

  async getItems ({ownerType, ownerId, ...params}) {
    const res = await get(`/owners/${ownerType}/${ownerId}/attachments`, { params })
    return res.data
  },

  async exportEntity(entityName, entityId, templateName) {
    const res = await get(`/export/entities/${toFirstLetter(entityName)}/${entityId}/templates/${templateName}`)
    fileApi.getItem(res.data?.file)
  },

  /**
   * Скачифает файл из url
   * @param {string} url - URL файла
   * @param {string} [name] - Название файла. Если не указано, то берётся из url (последнего значения после /)
   * @param {string} [extension] - Расширение файла. Если не указано, то берётся из имени файла в url (значение псле точки)
   */
  async downloadFile (url, name, extension) {
    if (!url) throw Error('Empty url')
    let filename = url.split('/').pop()
    const fileExtension = extension ?? getExtensionByName(filename)
    if (name) {
      filename = name + '.' + fileExtension
    }
    const res = await axios.get(url, { responseType: 'blob' })
    const blob = new Blob([res.data], { type: res.headers['content-type'] })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
    window.URL.revokeObjectURL(blob)
    link.remove()
  },
}

export default fileApi